import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "estimatif-lines" }
const _hoisted_2 = { class: "affix-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Estimatif de référence ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_select_categorie = _resolveComponent("select-categorie")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_estimatif_lines_table_base = _resolveComponent("estimatif-lines-table-base")!
  const _component_price_evolution_modal = _resolveComponent("price-evolution-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_affix, { "offset-top": 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { onClick: _ctx.openModalAdjustPrice }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ajuster les prix de l'ensemble de l'estimatif de référence ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_select_categorie, { "categories-selected": _ctx.categoriesSelected }, null, 8, ["categories-selected"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { type: "flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_estimatif_lines_table_base, {
              "categories-selected": _ctx.categoriesSelected,
              onUpdateCategorie: _ctx.updateCategorie
            }, null, 8, ["categories-selected", "onUpdateCategorie"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_price_evolution_modal, {
      "price-evolution": _ctx.modalPriceEvolutionData,
      "onUpdate:price-evolution": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalPriceEvolutionData) = $event)),
      onUpdatePrices: _ctx.updatePrices
    }, null, 8, ["price-evolution", "onUpdatePrices"])
  ]))
}